import { ExtendedTheme, styled } from 'parkdepot-shared/theme'
import { SupportedResultCodes } from '../types'

const getColours = ($theme: ExtendedTheme) =>
    ({
        Authorised: $theme.colors.positive700,
        Pending: $theme.colors.warning200,
        Error: $theme.colors.red700,
        Refused: $theme.colors.red700
    }) as const

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: $theme.sizing.scale700,
    padding: `4rem ${$theme.sizing.scale700}`,
    border: `1px solid ${$theme.colors.mono300}`,
    borderRadius: $theme.sizing.scale550
}))

export const Title = styled<'h1', { $variant: SupportedResultCodes }>('h1', ({ $theme, $variant }) => ({
    ...$theme.typography.HeadingSmall,
    textAlign: 'center',
    color: getColours($theme)[$variant] ?? $theme.colors.black,
    margin: 0
}))

export const Subtitle = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    margin: 0,
    textAlign: 'center'
}))

export const Icon = styled<'i', { $variant: SupportedResultCodes }>('i', ({ $theme, $variant }) => ({
    fontSize: $theme.sizing.scale900,
    color: getColours($theme)[$variant] ?? $theme.colors.black
}))
